import React, { useState, useEffect } from "react";
import { useIntl } from "react-intl";

import { Input, Button, Space, Select } from "@masterteam/mt-design-react";
import { ReactComponent as EditIcon } from "../../../assets/images/edit.svg";
import { ReactComponent as CorrectIcon } from "../../../assets/images/correct.svg";
import { ReactComponent as CloseIcon } from "../../../assets/images/close.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/images/delete.svg";
import { ReactComponent as ExpandIcon } from "../../../assets/images/arrowpointdwn.svg";

const TreeItem = (props) => {
  const {
    data,
    dragLeaveHandler,
    dragHandler,
    dropHandler,
    dragOverHandler,
    deleteEntityHandler,
    editEntityHandler,
    addEntityHandler,
    saveEntityHandler,
    cancelEntityHandler,
    parentsCount,
    editMode,
    isSelected,
    selectedEntity,
    isAllowedToDelete,
    isAddMode,
    isAddRootNode,
    users,
    usersLoading,
  } = props;

  const intl = useIntl();
  const isAr = intl.locale === "ar";

  const [state, setState] = useState({
    ID: null,
    ArabicName: "",
    EnglishName: "",
    ManagerModel: null,
  });

  useEffect(() => {
    if (editMode) {
      setState({
        ...state,
        ArabicName: selectedEntity.ArabicName,
        EnglishName: selectedEntity.EnglishName,
        ManagerModel: selectedEntity?.ManagerModel,
      });
    } else {
      setState({
        ArabicName: "",
        EnglishName: "",
        ManagerModel: null,
      });
    }
  }, [selectedEntity]);

  function saveEntity() {
    if (isAddMode) {
      let _newEntity = {
        ArabicName: state.ArabicName.trim(),
        EnglishName: state.EnglishName.trim(),
        ManagerModel: state?.ManagerModel,
        ParentID: selectedEntity.ID,
        LevelID: selectedEntity.ID ? selectedEntity?.LevelID + 1 : 1,
      };
      saveEntityHandler(_newEntity);
    } else {
      let _updatedEntity = { ...selectedEntity };
      _updatedEntity.ArabicName = state.ArabicName.trim();
      _updatedEntity.EnglishName = state.EnglishName.trim();
      _updatedEntity.ManagerModel = state.ManagerModel;
      _updatedEntity.LevelID = selectedEntity.ID
        ? selectedEntity?.LevelID + 1
        : 1;
      saveEntityHandler(_updatedEntity);
    }
  }

  return (
    <div
      className="tree-item"
      id={`node${data.ID}`}
      key={`node${data.ID}`}
      level-id={data?.LevelID}
      draggable={false}
      data-parent-id={`node${data.ParentID || 0}`}
      data-parents-count={parentsCount}
      onDragLeave={(event) => dragLeaveHandler(event)}
      onDragStart={(event) => dragHandler(event)}
      onDrop={(event) => dropHandler(event)}
      onDragOver={(event) => dragOverHandler(event)}
    >
      {isAddRootNode ? null : (
        <>
          {/* main Item with it's control : add , del , edit  */}
          <div
            className="item-details"
            style={{ display: editMode && isSelected ? "none" : "flex" }}
            onDragStart={(e) => {
              e.preventDefault();
              e.draggable = false;
            }}
          >
            <div className="d-flex">
              <button
                disabled={editMode || isAddMode}
                onMouseDown={(e) =>
                  (e.target.closest(".tree-item").draggable = true)
                }
                className={`drag-btn ${
                  editMode || isAddMode ? "btn-disabled" : ""
                }`}
              />

              <Button
                disabled={editMode || isAddMode}
                className={`new-tree-item`}
                fill={data.LevelID > 2 && "none"}
                onClick={() => {
                  if (data?.LevelID < 3) addEntityHandler();
                }}
              >
                {data.LevelID > 2 ? null : `+`}
              </Button>

              {data?.LevelID < 3 && (
                <Button
                  className="expand-btn"
                  fill="none"
                  Icon={ExpandIcon}
                  disabled={editMode || isAddMode}
                  style={{ backgroundColor: "none" }}
                  onClick={(e) =>
                    e.target.closest(".tree-item").classList.toggle("collapsed")
                  }
                />
              )}
              <Space size="large">
                <span>
                  {data.EnglishName} - {data.ArabicName}
                </span>
                <span>
                  <strong>
                    {intl.formatMessage({ id: "common.manager" })}:{" "}
                  </strong>
                  {data.ManagerModel?.DisplayName}
                </span>
              </Space>
            </div>

            <div className="d-flex" style={{ gap: "8px" }}>
              <Button
                tooltip-position="buttom"
                tooltip={intl.formatMessage({ id: "common.update" })}
                disabled={editMode || isAddMode}
                shape="square"
                fill="none"
                Icon={EditIcon}
                onClick={() => {
                  editEntityHandler();
                }}
              />
              <Button
                disabled={!isAllowedToDelete || editMode || isAddMode}
                className={!isAllowedToDelete && "wide-tooltip"}
                tooltip-position={
                  isAllowedToDelete ? "buttom" : isAr ? "right" : "left"
                }
                shape="square"
                fill="none"
                Icon={DeleteIcon}
                variant="error"
                onClick={() => {
                  deleteEntityHandler();
                }}
                tooltip={
                  isAllowedToDelete
                    ? intl.formatMessage({ id: "common.delete" })
                    : intl.formatMessage({ id: "org-structure.delete-warning" })
                }
              />
            </div>
          </div>

          {/* Add // Edit child Item ...............  */}

          <div
            className="item-details"
            style={{
              display: editMode && isSelected ? "flex" : "none",
              backgroundColor: "#fafafa",
            }}
          >
            <div className="d-flex edit-inputs">
              <Space className="full-width">
                <Input
                  placeholder={intl.formatMessage({
                    id: "common.english-name",
                  })}
                  value={state.EnglishName}
                  onChange={(event) => {
                    setState({ ...state, EnglishName: event.target.value });
                  }}
                />
                <Input
                  placeholder={intl.formatMessage({ id: "common.arabic-name" })}
                  style={{ textAlign: "right", direction: "rtl" }}
                  value={state.ArabicName}
                  onChange={(event) => {
                    setState({ ...state, ArabicName: event.target.value });
                  }}
                />

                <Select
                  options={users}
                  isLoading={usersLoading}
                  placeholder={intl.formatMessage({
                    id: "common.manager",
                  })}
                  value={state.ManagerModel}
                  getOptionLabel={(item) => item.DisplayName}
                  getOptionValue={(item) => item.UserName}
                  onChange={(val) => {
                    setState({ ...state, ManagerModel: val });
                  }}
                />
              </Space>
            </div>

            <div className="d-flex" style={{ gap: "8px" }}>
              <Button
                disabled={
                  !state.EnglishName.trim() ||
                  !state.ArabicName.trim() ||
                  !state.ManagerModel
                }
                tooltip-position="buttom"
                tooltip={intl.formatMessage({ id: "common.update" })}
                onClick={() => {
                  saveEntity();
                }}
                fill="none"
                shape="square"
                Icon={CorrectIcon}
              />

              <Button
                tooltip-position="buttom"
                tooltip={intl.formatMessage({ id: "common.cancel" })}
                fill="none"
                variant="error"
                shape="square"
                Icon={CloseIcon}
                onClick={() => {
                  cancelEntityHandler();
                }}
              />
            </div>
          </div>
        </>
      )}

      {/* add new parent Item  ......................... */}
      <div
        className="item-details"
        style={{
          display: isSelected && isAddMode ? "flex" : "none",
          backgroundColor: "#fafafa",
        }}
      >
        <div
          className="d-flex edit-inputs"
          style={{ marginInlineStart: "69px" }}
        >
          <Space className="full-width">
            <Input
              placeholder={intl.formatMessage({
                id: "common.english-name",
              })}
              value={state.EnglishName}
              onChange={(event) => {
                setState({ ...state, EnglishName: event.target.value });
              }}
            />
            <Input
              placeholder={intl.formatMessage({
                id: "common.arabic-name",
              })}
              style={{ textAlign: "right", direction: "rtl" }}
              value={state.ArabicName}
              onChange={(event) => {
                setState({ ...state, ArabicName: event.target.value });
              }}
            />
            <Select
              options={users}
              isLoading={usersLoading}
              placeholder={intl.formatMessage({
                id: "common.manager",
              })}
              value={state.ManagerModel}
              getOptionLabel={(item) => item.DisplayName}
              getOptionValue={(item) => item.UserName}
              onChange={(val) => {
                setState({ ...state, ManagerModel: val });
              }}
            />
          </Space>
        </div>

        <Space>
          <Button
            disabled={
              !state.EnglishName.trim() ||
              !state.ArabicName.trim() ||
              !state.ManagerModel
            }
            tooltip-position="buttom"
            tooltip={intl.formatMessage({ id: "common.add" })}
            onClick={() => {
              saveEntity();
            }}
            fill="none"
            shape="square"
            Icon={CorrectIcon}
          />

          <Button
            tooltip-position="buttom"
            tooltip={intl.formatMessage({ id: "common.cancel" })}
            fill="none"
            variant="error"
            shape="square"
            Icon={CloseIcon}
            onClick={() => {
              cancelEntityHandler();
            }}
          />
        </Space>
      </div>
    </div>
  );
};

export default TreeItem;
